import FollowUpDoac from "../../../../src/client/lta-antistolling/FollowUpDoac.js";
import * as React from 'react';
export default {
  FollowUpDoac,
  React
};